'use client';
import * as React from 'react';
import { Button, type ButtonProps } from './button';
import { useRouter } from 'next/navigation';
import { usePageTrackerStore, PageTracker } from 'react-page-tracker';
import { ChevronLeft } from 'lucide-react';
import { cn } from '@bells/core/lib/utils';

export const BackButton = React.forwardRef<
  HTMLButtonElement,
  ButtonProps & { backLink?: string; alwaysBack?: boolean; withStore?: boolean }
>(
  (
    {
      className,
      withStore,
      onClick,
      alwaysBack,
      children,
      backLink = '/',
      ...props
    },
    ref
  ) => {
    const router = useRouter();
    const isFirstPage = usePageTrackerStore((state) => state.isFirstPage);
    return (
      <div className='flex items-center justify-center'>
        <Button
          type='button'
          className={cn('h-8 w-8 border-none [&_svg]:size-6', className)}
          size='icon'
          variant='outline'
          ref={ref}
          onClick={(e) => {
            if (isFirstPage || alwaysBack) {
              withStore ? router.push(backLink) : router.replace(backLink);
            } else {
              router.back();
            }
            onClick?.(e);
          }}
          {...props}
        >
          {children ?? <ChevronLeft />}
        </Button>
      </div>
    );
  }
);
BackButton.displayName = 'BackButton';
export { PageTracker };
